import {HttpInterceptorFn} from '@angular/common/http';
import {inject} from '@angular/core';
import {HttpErrorResponse} from '@angular/common/http';
import {catchError, throwError} from 'rxjs';
import {AuthenticationService} from '../../modules/auth/services/authentication.service';

export const corsInterceptorFn: HttpInterceptorFn = (request, next) => {

    const authenticationService = inject(AuthenticationService);

    return next(request).pipe(
        catchError((error: HttpErrorResponse) => {
            if (error?.status === 0) {
                console.warn('Possible CORS issue detected, logging out...', error);
                authenticationService.logout();
            }
            return throwError(() => error);
        })
    );
};
